//
// Module for the Refund Step wizard's Initiate step
//
rs.module("participant/benefit/setup/refund/wizard/initiatestep",

    ["common/select-helper"],

    function (selectHelper) {

        // Initialize the module
        function initialize(jsSelectors, codeValues, flags, variables, backendUrls) {

            // Get the wizard's next button
            var wizardNextButton = $(`[data-wizard]`).js("_next");

            // get JS selectors
            var stepContainer = $.js(jsSelectors.stepContainer);
            var basisPlanSelect = stepContainer.js(jsSelectors.basisPlanSelect);
            var refundTypeSelect = stepContainer.js(jsSelectors.refundTypeSelect);
            var refundReasonSelect = stepContainer.js(jsSelectors.refundReasonSelect);
            var refundReasonSelectHelper = selectHelper.getHelper(refundReasonSelect);
            var refundReasonHidden = stepContainer.js(jsSelectors.refundReasonHidden);
            var separationDateInput = stepContainer.js(jsSelectors.separationDateInput);
            var separationDateHidden = stepContainer.js(jsSelectors.separationDateHidden);
            var effectiveDateInput = stepContainer.js(jsSelectors.effectiveDateInput);
            var initiateOnlyCheckBox = stepContainer.js(jsSelectors.initiateOnlyCheckBox);
            var skipInterestCheckBox = stepContainer.js(jsSelectors.skipInterestCheckBox);

            // On initialize of page, appropriately set wizard's next button text (Next or Finish)
            setWizardNextButtonText();

            // Conditionally set display of Wizard's next button text (Next or Finish) based on InitiateOnlyCheckBox
            function setWizardNextButtonText() {

                // Get the Next button's HTML (contains text and spinner icon)
                var buttonHtml = wizardNextButton.html();

                // Conditionally update text portion of button's HTML based on initiateOnlyCheckBox
                if (initiateOnlyCheckBox.is(":checked")) {
                    wizardNextButton.html(buttonHtml.replace('Next', 'Finish'));
                }
                else {
                    wizardNextButton.html(buttonHtml.replace('Finish', 'Next'));
                }
            }

            // Hookup basisPlanSelect change event
            basisPlanSelect.change(basisPlanChange);

            // Hookup refundTypeSelect change event
            refundTypeSelect.change(refundTypeChange);

            // Hookup separationDateInput change event
            separationDateInput.change(_.debounce(function () { separationDateChange(); }, 500));

            // Handle initiateOnlyCheckBox change
            initiateOnlyCheckBox.change(function () {

                // Enable/disable skipInterestCheckBox
                skipInterestCheckBox.prop("disabled", this.checked).setChecked(false);

                // Set wizard's next button text (Next or Finish)
                setWizardNextButtonText();
            });

            // Basis Plan change event
            function basisPlanChange() {
                var selectedPlanKey = parseInt(basisPlanSelect.val(), 10);
                var isDvPlan = Array.isArray(variables.dvPlanKeys) && variables.dvPlanKeys.indexOf(selectedPlanKey) !== -1;
                var hasDvDate = !!variables.dvPlanSeparationDate;

                if (isDvPlan && hasDvDate) {
                    // Default from DV and lock it
                    separationDateInput.val(variables.dvPlanSeparationDate).clearErrors();
                    separationDateHidden.val(variables.dvPlanSeparationDate);
                    separationDateInput.prop("disabled", true);
                }
                else {
                    // Enable/disable based on Refund Type
                    var selectedRefundType = refundTypeSelect.val();

                    if (selectedRefundType == codeValues.terminationTotalRefundType) {
                        if (!flags.separationDateDefaulted) {
                            separationDateInput.prop("disabled", false).val("").clearErrors();
                            separationDateHidden.val("");
                        }

                        effectiveDateInput.val("").clearErrors();
                    }
                    else {
                        separationDateInput.prop("disabled", true).clearErrors();

                        if (!flags.separationDateDefaulted) {
                            separationDateInput.val("");
                            separationDateHidden.val("");
                        }

                        effectiveDateInput.val(variables.currentDate).clearErrors();
                    }
                }
            }

            // Refund Type change event
            function refundTypeChange() {

                // Get selected Refund Type
                var selectedRefundType = refundTypeSelect.val();

                // Clear Refund Reason errors
                refundReasonSelect.clearErrors();

                // Populate applicable Refund Reasons based on selected Refund Type
                refundReasonSelectHelper.loadOptionsFrom(
                    backendUrls.getApplicableRefundReasons,
                    {
                        refundType: selectedRefundType
                    },
                    {
                        withBlank: selectedRefundType == codeValues.partialBalanceRefundType
                    });

                // Enable/Disable dependent fields
                if (selectedRefundType == codeValues.terminationTotalRefundType) {

                    refundReasonSelectHelper.setValue(codeValues.terminationTotalRefundReason).setDisabled(true);
                    refundReasonHidden.val(codeValues.terminationTotalRefundReason);

                    if (!flags.separationDateDefaulted) {
                        separationDateInput.prop("disabled", false).val("").clearErrors();
                        separationDateHidden.val("");
                    }
     
                    effectiveDateInput.val("").clearErrors();
                }
                else {
                    refundReasonSelectHelper.setValue("").setDisabled(false);
                    refundReasonHidden.val("");

                    separationDateInput.prop("disabled", true).clearErrors();

                    if (!flags.separationDateDefaulted) {
                        separationDateInput.val("");
                        separationDateHidden.val("");
                    }
                
                    effectiveDateInput.val(variables.currentDate).clearErrors();
                }
            }

            // Separation Date change event
            function separationDateChange() {

                // Get entered Separation Date
                var separationDate = separationDateInput.val();

                if (separationDate) {

                    separationDateInput.clearErrors();

                    // If the Separation Date was not system defaulted, populate Effective Date
                    if (!flags.separationDateDefaulted) {
                        var effectiveDate = new Date(separationDate);
                        var newEffectiveDate = new Date(
                            Date.UTC(
                                effectiveDate.getUTCFullYear(),
                                effectiveDate.getUTCMonth() + 1,
                                1,
                                effectiveDate.getUTCHours(),
                                effectiveDate.getUTCMinutes()
                            )
                        );
                        effectiveDateInput.val(new Date(newEffectiveDate).toISODateString()).clearErrors();
                    }
                }
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);